import {FC, useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {parseResultsSearch} from '../resultsParams'

interface PlaceholderSearchPageProps {
  title: string
}

const PlaceholderSearchPage: FC<PlaceholderSearchPageProps> = ({title}) => {
  const location = useLocation()
  const {q, type} = parseResultsSearch(location.search)

  useEffect(() => {
    const container = document.getElementById('kt_content_container')
    container?.classList.add('member-full-wrapper')
    return () => {
      container?.classList.remove('member-full-wrapper')
    }
  }, [])

  return (
    <div className='members-page members-search-page'>
      <div className='members-page__header'>
        <h1 className='members-page__title'>
          {title}
          <svg width='22' height='6' viewBox='0 0 22 6' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M14.1667 0.378906L20 5.37891H0' stroke='#151515' />
          </svg>
        </h1>
      </div>

      <div
        style={{
          padding: '80px 0',
          textAlign: 'center',
          color: '#666',
          fontFamily: 'Satoshi, sans-serif',
          fontSize: 16,
          lineHeight: 1.5,
        }}
      >
        <p style={{margin: 0, fontWeight: 500}}>Página en construcción.</p>
        {q && (
          <p style={{margin: '8px 0 0'}}>
            Búsqueda: <strong>&ldquo;{q}&rdquo;</strong>
            {type !== 'all' && (
              <>
                {' '}·{' '}Tipo: <strong>{type}</strong>
              </>
            )}
          </p>
        )}
      </div>
    </div>
  )
}

export {PlaceholderSearchPage}
